import React ,{useState ,useEffect} from 'react';
import styled from 'styled-components';
import StepButtom from '../../../fixbar/StepButtom'  
import dot_icon from '../../../../images/dot_icon.png' 
import { compressImage } from 'utils/utils.js';


export default function FitgroupChangestep1({groupInfo,subtit,marginTop,titname,paddingBottom,placeholder,updateNext,fitImg,setFitImg,setNewCoverImg,fitName,setFitName}) {
    const [next ,setNext] = useState(false);

    const fitImgChange = async (e) =>{ 
        let imgFile = e.target.files[0];
        let compressedImg = await compressImage(imgFile);
        setNewCoverImg(compressedImg);
        setFitImg(URL.createObjectURL(compressedImg));  
    }
    const fitNameChange = (e) =>{setFitName(e.target.value); }
    const fitImgwVaildate = () =>{ return fitImgChange.length == 1};
    const fitNamewVaildate = () =>{ return fitName.length > 1};

    useEffect(()=>{
        if(fitImgwVaildate() && fitNamewVaildate() )
                setNext(true);
        else
            setNext(false);
    },[fitImg,fitName]);

    return(
        <Fitgrouparea>
            <FitChangeinner>
                <Titbar>
                    <Imgtit>대표 이미지 </Imgtit>  
                    <Dot> <Fileinput type="file" onChange={fitImgChange}></Fileinput></Dot> 
                </Titbar>
            </FitChangeinner>
            {
                fitImg  ?
                <Fitimages><PreviewImg src={fitImg}></PreviewImg></Fitimages>
                : <Fitimages><PreviewImg src={fitImg}></PreviewImg></Fitimages>
            }
            

            <Titbar><Imgtit>{titname} </Imgtit></Titbar>
                <Subtit marginTop={marginTop} paddingBottom={paddingBottom}>{subtit}</Subtit>
            <Groupname type="text" placeholder={placeholder} onChange={fitNameChange} value={fitName}></Groupname>

            {
                next?
                <StepButtom text={"1/2"}
                    color={"#4e4e4e"} 
                    position={"fixed"}
                    prevdisplay={"flex"}
                    nextdisplay={"flex"}
                    updateNext={updateNext}
                    next={true}
                    // textClick={textClick}
                />
            :
                <StepButtom text={"1/2"}
                    color={"#4e4e4e"} 
                    position={"fixed"}
                    prevdisplay={"flex"}
                    nextdisplay={"flex"}
                    updateNext={updateNext}
                    bg={"#d8d8d8"}
                    next={false}
                    // textClick={textClick}
                />
            }
            
        
        </Fitgrouparea>
    );
}



const Fitgrouparea = styled.div `
    // padding-bottom: calc(100vw*(196/375));
`
const Imgtit = styled.p `
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    letter-spacing: 0.32px;
`
const Titbar = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: calc(100vw*(17/375)) calc(100vw*(11/375)) calc(100vw*(16/375)) calc(100vw*(17/375));
`
const FitChangeinner = styled.div`
    padding-top: calc(100vw*(51/375));
`
const Fitimages = styled.div`
    width: 100%;
    height: calc(100vw*(240/375));
    background-color: #f5f5f5;
`
const Fitinput = styled.input`
    display:none;
`
const Fitlabel = styled.label`
    display: block;
    text-align: center;
    width: 100%;
    height: 100%;
    padding: calc(100vw*(80/375)) 0;
`
const Fitimg = styled.span`
    display:block;
    width: calc(100vw*(49/375));
    height: calc(100vw*(40/375));
    margin: 0 auto calc(100vw*(10.5/375));
`
const Fitxt = styled.span`
    font-size: calc(100vw*(11/375));
    color: #7f7f7f;
`
const Groupname = styled.input`
    width: calc(100vw*(342/375));
    height: calc(100vw*(40/375));
    border-radius: calc(100vw*(5/375));
    border: solid calc(100vw*(1/375)) #d5d5d5;
    background-color: #ffffff;
    font-size: calc(100vw*(14/375));
    padding-left : calc(100vw*(6/375));
    margin-left : calc(100vw*(16/375));

    &::placeholder {
        color: #c6c6c6;
    }
`
const Subtit = styled.p`
    font-size: calc(100vw*(11/375));
    color: #707070;
    margin-top: ${props=>props.marginTop};
    padding-left: calc(100vw*(17/375));
    padding-bottom: ${props=>props.paddingBottom};
`
const Dot = styled.label`
    display:block;
    width: calc(100vw*(16/375));
    height: calc(100vw*(16/375));
    background-image : url(${dot_icon});
    background-repeat: no-repeat;
    background-size: calc(100vw*(16/375));
`
const Fileinput = styled.input`
    display:none;
`
const PreviewImg = styled.img`
    object-fit: cover;
    height: 100%;
    width: 100%;
`


